// extracted by mini-css-extract-plugin
export default {"banner":"OptimizationBanner_banner__V3NHn","title":"OptimizationBanner_title__cN7X+","text":"OptimizationBanner_text__AKUKG"};